/**
 * Common object represents common API endpoints for retrieving country and state information.
 */
const Common = {
  /**
   * Endpoint for retrieving a list of countries.
   * @memberof Common
   * @type {object}
   * @property {string} url - The URL for retrieving a list of countries.
   * @property {string} method - The HTTP method for retrieving a list of countries (GET).
   */
  country: {
    url: "/country",
    method: "GET",
  },

  /**
   * Endpoint for retrieving a list of states.
   * @memberof Common
   * @type {object}
   * @property {string} url - The URL for retrieving a list of states.
   * @property {string} method - The HTTP method for retrieving a list of states (GET).
   */
  state: {
    url: "/state",
    method: "GET",
  },

  /**
   * Endpoint for retrieving a list of notification.
   * @memberof Common
   * @type {object}
   * @property {string} url - The URL for retrieving a list of notification.
   * @property {string} method - The HTTP method for retrieving a list of notification (GET).
   */
  getNotification: {
    url: "/notification",
    method: "GET",
  },
  /**
   * Endpoint for retrieving a list of notification count.
   * @memberof Common
   * @type {object}
   * @property {string} url - The URL for retrieving a list of notification count.
   * @property {string} method - The HTTP method for retrieving a list of notification count (GET).
   */
  getUnreadNotificationCount: {
    url: "/unread-notification-count",
    method: "GET",
  },
  /**
   * Endpoint for updating read and unread status.
   * @memberof Common
   * @type {object}
   * @property {string} url - The URL for updating read and unread status.
   * @property {string} method - The HTTP method for updating read and unread status (PUT).
   */
  updateUnreadNotificationStatus: {
    url: "/notification/status",
    method: "PUT",
  },
};

// Export the Common object for use in other modules
export default Common;
